function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.1558 0.25636C6.79308 -0.0854534 6.20402 -0.0854534 5.84129 0.25636L2.12701 3.75653C1.76429 4.09834 1.76429 4.65345 2.12701 4.99526C2.48973 5.33708 3.07879 5.33708 3.44152 4.99526L5.57143 2.98813V8.74974C5.57143 9.23375 5.98638 9.62479 6.5 9.62479C7.01362 9.62479 7.42857 9.23375 7.42857 8.74974V2.98813L9.55848 4.99526C9.9212 5.33708 10.5103 5.33708 10.873 4.99526C11.2357 4.65345 11.2357 4.09834 10.873 3.75653L7.15871 0.25636H7.1558ZM1.85714 9.62479C1.85714 9.14078 1.44219 8.74974 0.928571 8.74974C0.414955 8.74974 0 9.14078 0 9.62479V11.3749C0 12.8242 1.24777 14 2.78571 14H10.2143C11.7522 14 13 12.8242 13 11.3749V9.62479C13 9.14078 12.585 8.74974 12.0714 8.74974C11.5578 8.74974 11.1429 9.14078 11.1429 9.62479V11.3749C11.1429 11.8589 10.7279 12.2499 10.2143 12.2499H2.78571C2.2721 12.2499 1.85714 11.8589 1.85714 11.3749V9.62479Z",
  fill: "black"
});

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.4a0e140c.svg";
export { ForwardRef as ReactComponent };